// extracted by mini-css-extract-plugin
export default {"body":"layout_body__owN-N"};